module.exports = __webpack_public_path__ + "img/launchpage2.a685d145.jpg";